import React from 'react';
import '../../estilos/PaginaInicio/Header.css';

const Header = () => {
    return (
        <header className="header">
            
        </header>
    );
};

export default Header;
